import { Controller } from '@hotwired/stimulus';

/**
 * Select navigate - visits the URL held in the chosen option's value (a picker between pages).
 * @example <div data-controller="select-navigate"><select data-action="change->select-navigate#go"><option value="/boards/1/settings">…</option></select></div>
 */
export default class extends Controller {
  go (event) {
    window.Turbo.visit(event.target.value);
  }
}
